import { configureStore } from '@reduxjs/toolkit';
import productDataReducer from './../../apps/kogan/features/productmanagement/slices/productsSlice'
import koganTabsSlice from '../../apps/kogan/features/productmanagement/slices/tabsSlice';
import koganTabProductsSlice from '../../apps/kogan/features/productmanagement/slices/tabProductsSlice';
import koganProductImagesSlice from '../../apps/kogan/features/productmanagement/slices/productImagesSlice';
export default configureStore({
  reducer: {
    koganProducts: productDataReducer,
    koganTabs: koganTabsSlice,
    koganTabProducts: koganTabProductsSlice,
    koganProductImages: koganProductImagesSlice
  },
});
